import { envVariables } from '@fabric-ui/utils';

/**
 * Centralized constants for the SOAR frontend application.
 */

const API_BASE = envVariables.VITE_API_URL || '';

export const APP_CONFIG = {
  API_PORT: 8026,
  BASE_URL: `${API_BASE}/socautomation/`,
};

export const API_ROUTES = {
  PLAYBOOKS: 'playbooks',
  AUTOMATION_RULE: 'automation/rule',
  CATALOG: 'catalog/trigger-objects',
  EXECUTION_HISTORY: 'history/executions',
};

export const entityToProjMapping: Record<string, string> = {
  INCIDENT: 'incidents',
  ALERT: 'uber_alerts',
  VULNERABILITY: 'vulnerabilities',
  FINDING: 'findings',
  ASSET: 'assets',
  USER: 'users',
};
